import { getToken } from "firebase/messaging";
import { messaging } from "../config/firebase";

export const getFCMToken = async () => {
    try {
        const permission = await Notification.requestPermission();
        if (permission !== "granted") return null;

        const token = await getToken(messaging, {
            vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY
        });

        console.log("🔥 FCM TOKEN:", token);
        return token;

    } catch (err) {
        console.error("Token error:", err);
    }
};